import { render } from "./StartScreen.vue?vue&type=template&id=34d4ce59&scoped=true"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"

import "./StartScreen.vue?vue&type=style&index=0&id=34d4ce59&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d4ce59"]])

export default __exports__